<template>
  <div class="content-notification-section h-auto">
    <NotificationCard></NotificationCard>
    <NotificationCard></NotificationCard>
  </div>
</template>

<script>
import NotificationCard from "@/components/notificationComps/NotificationCard";

export default {
  name: "ContentNotification",

  components: {
    NotificationCard
  }
};
</script>

<style lang="scss">
.content-notification-section {
  position: relative;
  margin-top: 20px;
  width: 100%;
}
</style>
